import heineken from "./heineken";
import prestige from "./prestige";
import redstripe from "./redstripe";
import dosequis from "./dosequis";
import tecate from "./tecate";
import strongbow from "./strongbow";
import birramoretti from "./birramoretti";
import dragonstout from "./dragonstout";
import tiger from "./tiger";
import sol from "./sol";
import lagunitas from "./lagunitas";

export const brands = {
  heineken,
  prestige,
  redstripe,
  dosequis,
  tecate,
  strongbow,
  birramoretti,
  dragonstout,
  tiger,
  sol,
  lagunitas,
};

export const globalWordings = {
  en: {
    selectYourProduct: "SELECT YOUR PRODUCT",
    product: "PRODUCT",
    chooseYourFormat: "CHOOSE YOUR FORMAT",
    moreInformation: "MORE INFORMATION",
    error: "Something went wrong",
    ageDisclaimer: {
      title: "PLEASE, SET YOUR BIRTHDAY IN THE FOLLOWING FORM",
      button: "ENTER",
      day: "DAY",
      month: "MONTH",
      year: "YEAR",
      error: "You must be of legal drinking age",
      footer:
        "You must be of legal drinking age, please don't share our content with anyone who is underage",
    },
    footer: {
      alcohol: "ALCOHOL & MODERATION",
      modal: {
        title: "LEGALS / ALCOHOL & MODERATION",
        responsibleConsumption:
          "Consuming alcohol is an individual choice and affects different people in different ways. Some studies have indicated that there may be a relationship between alcohol consumption and an increased risk of developing certain health issues. Heavy drinking on a regular basis has been connected to multiple illnesses, including liver disease, cardiovascular disease, dependency, and a heightened risk of certain types of cancer. 'Binge' drinking, which involves consuming large amounts of alcohol in a short period of time, is dangerous and can result in serious health issues. For some people moderate alcohol consumption may increase certain health risks and risks of certain types of cancer, such as breast cancer. In addition to pace, other factors that may influence the level of risk include amount and frequency of consumption, age, gender, genetics, and lifestyle. To that end, you should consult with your health care provider or medical professional to help you understand whether moderate drinking is compatible with your personal health circumstances.",
        link: "https://www.moderationmatters.com",
      },
    },
  },
  fr: {
    selectYourProduct: "SÉLECTIONNEZ VOTRE PRODUIT",
    product: "PRODUIT",
    chooseYourFormat: "CHOISISSEZ VOTRE FORMAT",
    moreInformation: "PLUS D'INFORMATIONS",
    error: "Quelque chose s'est mal passé",
    ageDisclaimer: {
      title:
        "POURRIER-VOUS, S’IL VOUS PLAÎT, INDIQUER VOTRE DATE D'ANNIVERSAIRE DANS LE FORMAT SUIVANT",
      button: "ENTRER",
      day: "JOUR",
      month: "MOIS",
      year: "ANNÉE",
      footer:
        "Vous devez avoir l'âge légal pour consommer de l'alcool. Ne partagez pas notre contenu avec des mineurs",
      error: "Vous devez avoir l'âge légal pour consommer de l'alcool",
    },
    footer: {
      alcohol: "ALCOHOL & MODERATION",
      modal: {
        title: "ALCOHOL & MODERATION",
        responsibleConsumption:
          "Consommées avec modération, la bière et les autres boissons alcoolisées de notre portefeuille peuvent faire partie d'un mode de vie équilibré. Nous sommes des brasseurs fiers de promouvoir une consommation responsable et de réduire l'usage nocif de l'alcool. Nous pensons qu'il est important que les consommateurs soient bien informés sur l'alcool, sur nos produits et sur la manière dont ils peuvent être consommés de manière responsable. Nous veillons à le souligner sur nos emballages, dans notre publicité et nos promotions, ainsi que dans le cadre de nos partenariats. Nous proposons une large gamme de boissons à différents taux d'alcool par volume (ABV), y compris de plus en plus d'options sans alcool et à faible teneur en alcool. La consommation d'alcool est un choix individuel. Les risques et les avantages personnels doivent être pris en compte avant de consommer de l'alcool. Certaines données ont montré qu'il existe un lien entre la consommation d'alcool et certains problèmes de santé. L'alcool a des effets différents selon les personnes. Pour certaines personnes, une consommation modérée d'alcool peut également augmenter certains risques pour la santé, tels que les problèmes cardiovasculaires, le diabète et certains types de cancer. Si vous avez d'autres questions ou préoccupations, n'hésitez pas à contacter votre médecin. Une consommation excessive d'alcool peut avoir des conséquences dangereuses à long terme, telles que la dépendance physique ou l'accoutumance à l'alcool, et doit toujours être évitée. Certaines personnes ne devraient jamais boire. Par exemple, les personnes qui n'ont pas l'âge légal pour consommer de l'alcool, qui sont enceintes, qui sont sur le point de conduire ou d'utiliser des machines, ou qui ne peuvent pas contrôler leur consommation d'alcool. Traduit avec DeepL.com (version gratuite)",
      },
    },
  },
};
